import React, { FC, useContext } from 'react';
import { View, Text, Image, StyleSheet, TouchableOpacity } from 'react-native';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import * as _ from 'lodash';
import Config from '../../constants/Config';
import { AnalyticsService } from '../../constants/Analytics';

import { AuthContext } from '../../contexts/auth/Store';
import { Context } from '../../contexts/feed/Store';
import { CartContext } from '../../contexts/cart/Store';
import moment from 'moment';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'
import { IOrderGroupItem } from '../../interfaces/order';
import http from '../../utils/http';

const analytics = new AnalyticsService

const FeedImage = ({ _id }) => {
    const [state] = useContext(Context)
    const image = state.feeds.filter(item => item._id === _id)
    const exist = _.has(image[0], 'upload.path')
    return exist ? <Image source={{ uri: Config.uploadUrl + image[0].upload.path }} style={styles.cardImage} /> : null
}

const LikesInfo = ({ _id, likes }) => {
    const auth = useContext(AuthContext)
    let thisUserLikes = likes.filter(item => item.buyer_id === auth.getUserData.buyerId || null).length > 0

    const message = () => {
        if (likes.length < 1) {
            return null
        }
        if (thisUserLikes) {
            if (likes.length > 2) {
                return 'You and ' + (likes.length - 1) + ' other people like this';
            }
            if (likes.length > 1) {
                return 'You and ' + (likes.length - 1) + ' other person like this';
            }
            return 'You like this';
        }

        if (likes.length > 1) {
            return (likes.length) + ' people like this';
        }
        return likes.length + ' person likes this';
    }

    return (
        message() &&
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignContent: 'center', marginRight: 8, }}>
            <Icon name='md-thumbs-up' color='#9DA5B0' size={13} style={{ alignSelf: 'center', margin: 3 }} />
            <Text style={[styles.infoText, { color: '#9DA5B0' }]} > {message()} </Text>
        </View>
    )
}
const ExpiryInfo = ({ checklist }) => {
    if (!checklist) { return null }
    let hasExpiry = checklist.filter(item => item.type === 'expires')
    let expires = null
    let display = null

    if (hasExpiry && hasExpiry.length > 0) {
        expires = hasExpiry[0].value
    }

    if (expires) {
        let exp = moment.unix(expires),
            now = moment(new Date()),
            notExpired = moment(now).isBefore(exp);

        if (notExpired) {
            display = now.to(exp, true)
        }
    }

    return expires &&
        <View style={{ flexDirection: 'row', justifyContent: 'center', alignContent: 'center' }}>
            <Icon name='ios-time' color='#F9B13D' size={13} style={{ alignSelf: 'center', margin: 3 }} />
            {
                display ? <Text style={[styles.infoText, { color: '#F9B13D' }]}>{display} left</Text>
                    : <Text style={[styles.infoText, { color: '#F9B13D' }]}>Expired</Text>
            }
        </View>
}

const LikeButton = ({ _id, likes, type }) => {

    const auth = useContext(AuthContext);
    const [state, dispatch] = useContext(Context);
    const token = auth.getUserData.token;
    const buyer_id = auth.getUserData.buyerId;
    const buyer_phone = auth.getUserData.buyerData.phone;
    let thisUserLikes = likes.filter(item => item.buyer_id === buyer_id).length > 0

    const toggleLike = () => {

        // dislike
        if (thisUserLikes) {
            //api call
            let temp = likes.filter(item => item.buyer_id === buyer_id)[0]
            dispatch({ type: 'UNLIKE_FEED', payload: { _id, buyer_id } })
            let formData = new FormData()
            formData.append('_id', temp._id)
            http.post('like/delete', formData, token).then(res => {
                if (res.code !== 200) {
                    // console.log('abort dislike', res)
                    dispatch({ type: 'LIKE_FEED', payload: { _id: _id, data: temp } })
                }
                else {
                    // console.log('graceful dislike', res)
                }
            })
            return
        } else {

            // console.log('attempted like')
            const parent_type = type ? type : 'promotion'
            const parent_id = _id
            const meta = buyer_phone

            let formData = new FormData
            formData.append('parent_id', parent_id)
            formData.append('parent_type', parent_type)
            formData.append('meta', meta)
            formData.append('buyer_id', buyer_id)

            let temp = {
                buyer_id,
                meta,
                parent_id,
                parent_type,
            }

            dispatch({ type: 'LIKE_FEED', payload: { _id: _id, data: temp } })

            //api call
            http.post('like/create', formData, token).then(res => {
                if (res.code !== 200 && res.message !== 'Already liked.') {
                    // console.log('abort like', res)
                    dispatch({ type: 'UNLIKE_FEED', payload: { _id, buyer_id } })
                }
                else {
                    // console.log('gracefully liked', res)
                    temp['_id'] = res.data
                    dispatch({ type: 'LIKE_FEED', payload: { _id: _id, data: temp } })

                    // log visit event
                    analytics.logEvent('Liked Promotion', auth.getUserData.buyerData, {
                        promotion_id: _id,
                    });
                }
            })
        }

    }

    return (
        <TouchableOpacity
            style={styles.cardFooterButton}
            onPress={toggleLike}
        >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Icon style={styles.cardFooterButtonIcon} name='ios-thumbs-up' size={24} color={thisUserLikes ? '#3B54EC' : '#9DA5B0'} />
                <Text style={[styles.cardFooterButtonText, { color: thisUserLikes ? '#3B54EC' : '#212121' }]}>{thisUserLikes ? 'Liked' : 'Like'}</Text>
            </View>
        </TouchableOpacity>
    )
}

const VisitButton = ({ checklist, openVisitModal, visit }) => {
    if (!checklist) { return null }

    let hasAction = checklist.filter(item => item.type !== 'expires')
    let types = hasAction.map(item => item.type)[0]
    const data = hasAction[0]
    let renderItem = null

    switch (types) {
        case 'visit':
            renderItem = <TouchableOpacity
                style={[styles.cardFooterButton, { borderLeftColor: 'rgba(0,0,0,0.05)', borderLeftWidth: 1, borderStyle: 'solid' }]}
                onPress={() => openVisitModal({ isActive: true, data })}
            >
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Icon style={styles.cardFooterButtonIcon} name='ios-navigate' size={24} color={visit ? '#3B54EC' : '#9DA5B0'} />
                    <Text style={[styles.cardFooterButtonText, { color: visit ? '#3B54EC' : null }]}>Visit me</Text>
                </View>
            </TouchableOpacity>
            break;
        case 'call':
            renderItem = <TouchableOpacity
                style={[styles.cardFooterButton, { borderLeftColor: 'rgba(0,0,0,0.05)', borderLeftWidth: 1, borderStyle: 'solid' }]}
                onPress={() => openVisitModal({ isActive: true, data })}
            >
                <View style={{ flexDirection: 'row', alignItems: 'center' }} >
                    <Icon style={styles.cardFooterButtonIcon} name='ios-call' size={24} color='#9DA5B0' />
                    <Text style={styles.cardFooterButtonText}>Call now</Text>
                </View>
            </TouchableOpacity>
            break;
    }

    return renderItem
}

const BuyButton: FC<{ promo: any, openCartModal: Function }> = ({ promo, openCartModal }) => {
    const [cartState, cartDispatch] = useContext(CartContext);
    if (!promo) { return null }
    const trigger = promo.trigger
    const cartItem: IOrderGroupItem = cartState?.order_group_items?.find((item: IOrderGroupItem) => item.product?._id === promo.product_id)

    let renderItem = cartItem
        ? <TouchableOpacity
            style={[styles.cardFooterButton, { borderLeftColor: 'rgba(0,0,0,0.05)', borderLeftWidth: 1, borderStyle: 'solid' }]}
            onPress={() => openCartModal(cartItem.product)}
        >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Icon style={styles.cardFooterButtonIcon} name='md-appstore' size={24} color='#3B54EC' />
                <Text style={[styles.cardFooterButtonText, { color: '#3B54EC' }]}>Buy Product</Text>
            </View>
        </TouchableOpacity>
        : <TouchableOpacity
            style={[styles.cardFooterButton, { borderLeftColor: 'rgba(0,0,0,0.05)', borderLeftWidth: 1, borderStyle: 'solid' }]}
            onPress={() => openCartModal(promo.product)}
        >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Icon style={styles.cardFooterButtonIcon} name='md-appstore' size={24} color='#9DA5B0' />
                <Text style={[styles.cardFooterButtonText]}>Buy Product</Text>
            </View>
        </TouchableOpacity>

    return renderItem
}

class SingleFeed extends React.Component {

    constructor(props: any) {
        super();
        this.props = props
        this.openVisitModal = props.openVisitModal;
        this.openCartModal = props.openCartModal;
    }

    render() {
        return (
            <View>
                <View style={styles.card}>
                    <View style={styles.cardHeader}>
                        <View style={styles.cardHeaderIcon}>
                            <Image source={require('../../assets/images/main/PromoIcon.png')} style={{ width: 32, height: 32 }} />
                        </View>
                        <View style={{ flexGrow: 1 }}>
                            <Text style={styles.cardHeaderTitle} numberOfLines={1}>{this.props.title}</Text>
                            <Text style={styles.cardHeaderSubtitle} numberOfLines={1}>{_.has(this.props, 'manufacturer.name') ? this.props.manufacturer.name : '...'}</Text>
                        </View>
                        <View style={styles.cardHeaderMore}>
                            <Icon name='ios-more' size={16} />
                        </View>
                    </View>
                    <View style={styles.cardImageWrapper}>
                        <FeedImage _id={this.props._id} />
                    </View>
                    <View style={styles.cardBody}>
                        <Text numberOfLines={3}>
                            {this.props.description}
                        </Text>
                        <View style={{ flexDirection: 'row', marginTop: 13 }}>
                            <LikesInfo _id={this.props._id} likes={this.props.likes} />
                            <ExpiryInfo expires={this.props.expires} checklist={this.props.promotion_checklist} />
                        </View>
                    </View>
                    <View style={styles.cardFooter}>
                        <LikeButton _id={this.props._id} likes={this.props.likes} type={this.props.type} />
                        {/* <VisitButton checklist={this.props.promotion_checklist} openVisitModal={this.openVisitModal} visit={this.props.visit}/> */}
                        {/* { ['QTY', 'VALUE'].includes(this.props.trigger) && <BuyButton promo={this.props} openCartModal={this.openCartModal} openCartModal={this.openCartModal} /> } */}
                    </View>
                </View>
            </View>
        )
    }
}

export default SingleFeed

const styles = StyleSheet.create({
    card: {
        width: '100%',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'rgba(0,0,0,0.05)',
        borderRadius: 10,
        backgroundColor: '#FFFFFF',
        marginBottom: 16,
        // boxShadow: '0 1px 1px 0 rgba(0,0,0,0.01)',
    },
    cardHeader: {
        flexDirection: 'row',
        paddingHorizontal: 16.5,
        paddingTop: 16.5,
        paddingBottom: 11,
    },
    cardHeaderTitle: {
        ...FontStyles.dark,
        ...FontStyles.size15,
        ...FontStyles.lh18,
        ...FontStyles.medium,
        marginBottom: 3,
        width: 226,
        height: 18,
    },
    cardHeaderSubtitle: {
        color: Colors.shades._7,
        ...FontStyles.size12,
        ...FontStyles.lh12,
        ...FontStyles.normal,
    },
    cardHeaderIcon: {
        marginRight: 8,
    },
    cardImageWrapper: {
        backgroundColor: '#ddd'
    },
    cardImage: {
        width: '100%',
        height: undefined,
        aspectRatio: 328 / 191,
    },
    cardBody: {
        paddingHorizontal: 16.5,
        paddingVertical: 13,
    },
    infoText: {
        marginTop: 3,
        color: Colors.shades._7,
        ...FontStyles.size13,
        ...FontStyles.lh13,
        ...FontStyles.normal,
        alignSelf: 'center',
    },
    cardFooter: {
        flexDirection: 'row',
        borderTopColor: 'rgba(0,0,0,0.05)',
        borderTopWidth: 1,
        borderStyle: 'solid',
        justifyContent: 'space-evenly',
        alignContent: 'stretch',
    },
    cardFooterButton: {
        height: 47,
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        width: '50%',
    },
    cardFooterButtonIcon: {
        marginHorizontal: 4,
        marginVertical: 5,
    },
    cardFooterButtonText: {
        color: Colors.shades._7,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        marginLeft: 4,
    },
})